export interface DevelopmentReadinessCapability {
  environment?: string;
  development_catalogue_active?: boolean;
}

/**
 * The production-readiness override is a development UI affordance only.
 * Production composition never exposes a usable override path.
 */
export function canBypassProductionReadiness(
  capability: DevelopmentReadinessCapability | undefined,
): boolean {
  return capability?.development_catalogue_active === true
    && capability.environment !== 'production';
}

/**
 * Returns whether the UI should deliberately gate calculation on the open
 * production-readiness state. Intrinsic backend engineering validation is
 * never affected by this switch.
 */
export function productionReadinessBlocksCalculation(
  capability: DevelopmentReadinessCapability | undefined,
  bypassEnabled: boolean,
): boolean {
  if (!canBypassProductionReadiness(capability)) return false;
  return !bypassEnabled;
}
